import { render, staticRenderFns } from "./salesOrders.vue?vue&type=template&id=1ef23ac6"
import script from "./salesOrders.vue?vue&type=script&lang=js"
export * from "./salesOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports